/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} St_Inv_TitleInputs */

const en_st_inv_title = /** @type {(inputs: St_Inv_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invitation`)
};

const id_st_inv_title = /** @type {(inputs: St_Inv_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Undangan`)
};

/**
* | output |
* | --- |
* | "Invitation" |
*
* @param {St_Inv_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const st_inv_title = /** @type {((inputs?: St_Inv_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<St_Inv_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_st_inv_title(inputs)
	return en_st_inv_title(inputs)
});